import { useEffect, useState } from 'react';
import { lighten } from 'polished';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { withTracker } from '@/tracker';
import { colors } from '@/themes';
import listMarkdownFiles from '@/ssr-props-getters/list-markdown-files';
import useNavbarBackground from '@/hooks/use-navbar-background';
import SEO from '@/components/seo';
import Hero from '@/components/policies/hero';
import Policies from '@/components/policies/policies';

dayjs.extend(customParseFormat);

const Blog = ({ data }) => {
  const [policies, setPolicies] = useState([]);

  useNavbarBackground(lighten(.35, colors.brand.primary));

  useEffect(() => {
    setPolicies(data.sort((a, b) => {
      const aDate = dayjs(a.date, 'MMMM Do, YYYY');
      const bDate = dayjs(b.date, 'MMMM Do, YYYY');

      return aDate.isBefore(bDate);
    }))
  }, [data]);

  return (
    <>
      <SEO
        title="Bidali Policies & Procedures"
        description="Our policies and procedures that describe how we operate." />
      <Hero />
      <Policies policies={policies} />
    </>
  );
};

export default withTracker(Blog);

export async function getStaticProps () {
  return listMarkdownFiles('policies');
}
